import React from 'react';

/**
 * Device bezel (handoff "About the design file", point 2: rebuild the bezel
 * in CSS and drop a screenshot inside it - do not hand-build the screens).
 *
 * The screens are 2× exports of the design reference's phone screens, served
 * as WebP with a PNG fallback. The bezel keeps the design's 402×874 canvas,
 * scaled by --ps (App.css), so the hero and the screens strip can size the
 * same device independently.
 */
const Phone = ({ webp, png, alt, eager = false }) => (
  <div className="phone-outer">
    <div className="phone-inner">
      <div className="phone-screen">
        <div className="phone-island" aria-hidden="true" />
        <picture>
          <source type="image/webp" srcSet={webp} />
          <img
            src={png}
            alt={alt}
            width="402"
            height="874"
            loading={eager ? 'eager' : 'lazy'}
            decoding={eager ? 'sync' : 'async'}
            fetchPriority={eager ? 'high' : 'auto'}
          />
        </picture>
      </div>
    </div>
  </div>
);

export default Phone;
